export const BULK_UPLOAD_DRAFT_QUERY_KEY = 'bulk-upload-draft';
